import { DEFAULT_VOICE_BLOB_STYLE, DEFAULT_BLOB_COLORS } from "@brandclub/bc-widgets";
import { useVoiceThemeContext } from "./VoiceThemeProvider.js";
function useVoicePersona() {
  var _a, _b, _c, _d, _e, _f;
  const { persona, visual } = useVoiceThemeContext();
  const blobStyle = (visual == null ? void 0 : visual.blobStyle) ?? DEFAULT_VOICE_BLOB_STYLE;
  const blobColorsAll = {
    aurora: { ...DEFAULT_BLOB_COLORS.aurora, ...(_a = visual == null ? void 0 : visual.blobColors) == null ? void 0 : _a.aurora },
    organic: { ...DEFAULT_BLOB_COLORS.organic, ...(_b = visual == null ? void 0 : visual.blobColors) == null ? void 0 : _b.organic },
    particle: { ...DEFAULT_BLOB_COLORS.particle, ...(_c = visual == null ? void 0 : visual.blobColors) == null ? void 0 : _c.particle },
    waveform: { ...DEFAULT_BLOB_COLORS.waveform, ...(_d = visual == null ? void 0 : visual.blobColors) == null ? void 0 : _d.waveform },
    ripple: { ...DEFAULT_BLOB_COLORS.ripple, ...(_e = visual == null ? void 0 : visual.blobColors) == null ? void 0 : _e.ripple },
    metaball: { ...DEFAULT_BLOB_COLORS.metaball, ...(_f = visual == null ? void 0 : visual.blobColors) == null ? void 0 : _f.metaball }
  };
  return {
    assistantName: persona.assistantName || "Benny",
    voiceId: persona.voiceId,
    blobStyle,
    blobColors: blobColorsAll[blobStyle],
    blobColorsAll
  };
}
export {
  useVoicePersona
};
//# sourceMappingURL=useVoicePersona.js.map
